import React from 'react';

import Modal from '~/components/modals/modal';

import styles from '~/components/modals/simple-text/simple-text-modal.module.scss';

const SimpleTextModal = ({ onClose, isOpen, content }) => {
  return (
    <Modal onClose={onClose} isOpen={isOpen}>
      <Content content={content} />
    </Modal>
  );
};

const Content = ({ content }) => (
  <div className={styles.simpleTextModal}>
    <h2>{content?.header}</h2>
    {content?.body}
  </div>
);

export default SimpleTextModal;
